import * as React from "react"

import { Button, type ButtonProps, type DistributiveOmit } from "@coval/ui"
import { FileText } from "lucide-react"

/** A labelled button, so the icon-only tooltip props are not its caller's to set. */
type ReportButtonProps = DistributiveOmit<
  ButtonProps,
  | "asChild"
  | "children"
  | "disabledReason"
  | "icon"
  | "tooltip"
  | "tooltipProps"
  | "type"
  | "variant"
>

/** Launches the Reports workflow for the current table selection. */
export const ReportButton = React.forwardRef<
  HTMLButtonElement,
  ReportButtonProps
>((props, ref) => (
  <Button ref={ref} type="button" variant="secondary" {...props}>
    <FileText />
    Generate Report
  </Button>
))

ReportButton.displayName = "ReportButton"
